export function buildIcertisAgreementLink(params: { icmBaseUrl: string; entityName: string; sysId: string }): string {
  const origin = new URL(params.icmBaseUrl).origin
  const query = new URLSearchParams({ entityName: params.entityName, id: params.sysId })
  return `${origin}/Agreement/Details?${query.toString()}`
}
